import Equipment from '../../models/Equipment';
import { ROUTES } from '../../../../config/routes';
import translations from './locales';

const xm20 = new Equipment({
  id: 'xm20',
  name: 'XM20',
  displayName: { main: 'XM20' },
  path: ROUTES.xm20Intro,
  assetDirectory: '/Equipment/xm20',
  translations,
  image: { file: 'machine.png', width: 1366, height: 1152 },
  video: {
    file: 'introduction.mp4',
    poster: 'video-poster.jpg',
    fallbackLanguage: 'en',
    files: { ko: 'introduction.mp4', en: 'introduction-en.mp4' },
  },
  catalog: {
    fallbackLanguage: 'en',
    files: { ko: 'catalog.png', en: 'catalog-en.png', zh: 'catalog-zh.png' },
  },
  badges: [
    { id: 'diameter', valueKey: 'diameterTag' },
    { id: 'spindle', value: '10,000 rpm' },
  ],
  metrics: [
    { id: 'diameter', labelKey: 'specifications.maxDiameter.label', value: 'Ø20', unit: 'mm' },
    { id: 'spindle', labelKey: 'specifications.mainSpindle.label', value: '10,000', unit: 'rpm' },
    { id: 'stroke', labelKey: 'specifications.z1Stroke.label', value: '205', unit: 'mm' },
    { id: 'cross', labelKey: 'crossPower', value: '2.5', unit: 'kW' },
  ],
  features: ['rigidity', 'crossTools', 'backTools', 'guideBush'],
  specifications: [
    { id: 'nc', value: 'Fanuc 32i-B Plus' },
    { id: 'maxDiameter' },
    { id: 'z1Stroke' },
    { id: 'mainSpindle', value: '10,000 rpm · 2.2 / 3.7 kW' },
    { id: 'turningTools', value: '6 × (□12 mm)' },
    { id: 'frontTools', value: '3 × ER16' },
    { id: 'crossTools' },
    { id: 'crossSpeed', value: '6,000 rpm · 2.5 kW' },
    { id: 'bAxisTools' },
    { id: 'bAxisSpeed' },
    { id: 'subSpindle', value: '10,000 rpm · 2.2 / 3.7 kW' },
    { id: 'backTools' },
    { id: 'backSpeed', value: '9,000 rpm · 1.0 kW' },
    { id: 'dimensions', value: '2,160 × 1,200 × 1,900 mm' },
    { id: 'weight' },
    { id: 'power' },
    { id: 'air', value: '62 L/min' },
  ],
  specificationNoteKey: 'specificationNote',
  options: ['automaticBAxis', 'backEight', 'speedMultiplier', 'threeAxisLive', 'frontToolHolder', 'odToolHolder'],
  optionImages: { automaticBAxis: 'automaticBAxis.png', backEight: 'backEight.png' },
});

export default xm20;
